import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

const Media = () => {
  const { t } = useTranslation()
  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const handleShow = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const images = [
    'https://res.cloudinary.com/drt6vurtt/image/upload/v1743348709/gems/gems1_v1xlsi.webp',
    'https://res.cloudinary.com/drt6vurtt/image/upload/v1743348714/gems/gems2_wk8ang.webp',
    'https://res.cloudinary.com/drt6vurtt/image/upload/v1743348719/gems/gems3_wxklkp.webp',
    'https://res.cloudinary.com/drt6vurtt/image/upload/v1743348714/gems/gems4_lgbou1.webp',
    'https://res.cloudinary.com/drt6vurtt/image/upload/v1743348719/gems/gems5_e93onl.webp',
    'https://res.cloudinary.com/drt6vurtt/image/upload/v1743348713/gems/gems6_dfe40d.webp',
    'https://res.cloudinary.com/drt6vurtt/image/upload/v1743348726/gems/gems7_chf5m7.webp',
    'https://res.cloudinary.com/drt6vurtt/image/upload/v1743348723/gems/gems8_wo7h53.webp',
  ];
  return (
    <>
      <section className="media-section">
        <div className="first-para" style={{ margin: "0" }}>
          <h2>{t('Gems-detailt44')} <span></span></h2>
        </div>
        <div className="bottom-gallery">
        {images.map((image, index) => (
            <div className="single-gallery" key={index}>
              <img
                src={image}
                alt={`img-${index}`}
                className="img-fluid"
                onClick={() => handleShow(image)}
                style={{ cursor: 'pointer' }}
              />
            </div>
          ))}
          
        </div>
      </section>

      <Modal className='common-modal-style image-preview' show={show} onHide={handleClose} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className='p-0'>
          <img src={selectedImage} alt="Selected" className="img-fluid w-100" />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Media
